module.exports = __webpack_public_path__ + "media/images/svg/cursor-icon-video-a82c8f5f59ce48bef17e387b8e844824.svg";